import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { StyledFormSection } from './_elements';
import { Stack as FracStack } from '@src/types/Stacks';
import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@src/store/storeConnector';

interface FormValues {
  stackId: string;
  startCommands: string[];
  stopCommands: string[];
}

function CommandsStackSection({
  stacks,
  siteMeta,
}: { stacks: FracStack[]; siteMeta: SiteMeta }) {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <StyledFormSection>
      <Typography variant='h6' sx={{ mt: 2 }}>
        Commands
      </Typography>
      <Stack spacing={2} sx={{ mt: 2 }} direction={'row'}>
        <Controller
          name='startCommands'
          control={control}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id='select-start-command'>
                Beginning Commands
              </InputLabel>
              <Select
                {...field}
                multiple
                error={!!errors.startCommands}
                labelId='select-start-command'
                label='Beginning Commands'
                renderValue={(selected) => selected.join(', ')}
              >
                {siteMeta?.ui.EventCommands?.map(
                  ({ Name: name, Command: command }) => (
                    <MenuItem key={command} value={command}>
                      <Checkbox checked={field.value.includes(command)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          )}
        />

        <Controller
          name='stopCommands'
          control={control}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id='select-stop-command'>Ending Commands</InputLabel>
              <Select
                {...field}
                multiple
                error={!!errors.stopCommands}
                labelId='select-stop-command'
                label='Ending Commands'
                renderValue={(selected) => selected.join(', ')}
              >
                {siteMeta?.ui.EventCommands?.map(
                  ({ Name: name, Command: command }) => (
                    <MenuItem key={command} value={command}>
                      <Checkbox checked={field.value.includes(command)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          )}
        />
      </Stack>
      <Controller
        name='stackId'
        control={control}
        render={({ field }) => (
          <FormControl fullWidth sx={{ mt: 4 }}>
            <InputLabel id='select-stack'>Stack ID</InputLabel>
            <Select
              {...field}
              error={!!errors.stackId}
              labelId='select-stack'
              label='Stack ID'
            >
              {stacks?.map((stack) => (
                <MenuItem key={stack.id} value={stack.id}>
                  {stack.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
    </StyledFormSection>
  );
}

export default storeConnector(CommandsStackSection, {
  config: ['siteMeta'],
});
